import { z } from 'zod';
export const EXPERIMENT_STATUSES = ['draft', 'running', 'paused', 'completed'];
export const EXPERIMENT_TYPES = ['subject', 'body', 'cta', 'sequence_path'];
export const EXPERIMENT_PRIMARY_METRICS = [
    'reply_rate',
    'positive_reply_rate',
    'click_rate',
    'unsub_rate',
];
export const campaignExperimentVariantSchema = z.object({
    variant_key: z
        .string()
        .min(1)
        .max(8)
        .regex(/^[A-Za-z0-9]+$/),
    label: z.string().max(120).optional().nullable(),
    weight: z.number().int().min(1).max(1000).default(50),
    sequence_id: z.string().uuid(),
});
export const campaignExperimentUpsertSchema = z.object({
    name: z.string().min(1).max(200).optional(),
    experiment_type: z.enum(EXPERIMENT_TYPES).optional().default('sequence_path'),
    primary_metric: z.enum(EXPERIMENT_PRIMARY_METRICS).optional().default('reply_rate'),
    variants: z.array(campaignExperimentVariantSchema).min(2).max(8),
});
//# sourceMappingURL=campaignExperiment.js.map